import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-9xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-2xl text-gray-600 mb-6">
        {t("oopsThePageYoureLookingForDoesntExist")}
      </p>
      <Link to="/accueil" className="text-lg text-blue-500 hover:underline">
        {t("goBackToHome")}
      </Link>
    </div>
  );
};

export default NotFoundPage;
